import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { i18n } from '../../../../../helpers/i18n';
import { useActions } from '../../../../../hooks';
import { selectJoinWithCameraOff, toggleJoinWithCameraOffAction } from '../../../../settings';
import { SettingsTumbler } from './settings-tumbler';

export const JoinWithCameraOffTumbler: FunctionComponent = () => {
    const { toggleJoinWithCameraOff } = useActions({ toggleJoinWithCameraOff: toggleJoinWithCameraOffAction });

    const joinWithCameraOff = useSelector(selectJoinWithCameraOff);

    const onChange = () => toggleJoinWithCameraOff(!joinWithCameraOff);

    return (
        <SettingsTumbler
            label={i18n('settings-v2', 'video-join-with-camera-off')}
            checked={joinWithCameraOff}
            onChange={onChange}
            testId="join-with-camera-off-tumbler"
        />
    );
};
